import { render, staticRenderFns } from "./GlobalSearchListItem.vue?vue&type=template&id=194e03cc&scoped=true&lang=pug"
import script from "./GlobalSearchListItem.vue?vue&type=script&lang=js"
export * from "./GlobalSearchListItem.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearchListItem.vue?vue&type=style&index=0&id=194e03cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194e03cc",
  null
  
)

export default component.exports